import React from 'react'
import './styles.scss'
import listParteien from './parteien-data.csv'

export function KantonParteien(props) {
    const filteredList = listParteien.filter(val => val.kanton === props.kanton)
    return filteredList.map((p, index) => {
  
      return (
 
          <tr className='top aligned' key={p.kanton + index}>
            <td className='parteiTitel'>{p.partei}</td>
            <td className='top aligned square'>
              <div className='squareWrapper'>
                {Array(parseInt(p.sitze, 10))
                  .fill(null)
                  .map((s, index) => {
                    return <div className={`square ${p.partei}`} key={index} />
                  })}
                  <span style={{lineHeight: '1.1em'}}>{p.sitze === '0' ? 'Keine' : ''}</span>
              </div>
            </td>
            <td className='trendWrapper'>
              <i className={p.trend} />
            </td>
          </tr>
  
      )
    })
  }